module.exports = __webpack_public_path__ + "media/sample.825949bf.mp4";